import React from "react";
import { IShop } from "interfaces";
import cls from "./shopLogo.module.scss";
import getImage from "utils/getImage";
import FallbackImage from "components/fallbackImage/fallbackImage";

type Props = {
  data: IShop;
};

export default function ShopLogo({ data }: Props) {
  return (
    <div className={cls.logo}>
      <FallbackImage
        fill
        src={getImage(data.logo_img)}
        alt={data.translation?.title}
        sizes="60px"
        quality={90}
      />
    </div>
  );
}
